export default __webpack_public_path__ + "static/media/truckBW.8f74772a.jpg";